/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable no-restricted-syntax */
import { Icon } from "@chakra-ui/react";
import { FiExternalLink, FiArrowRight } from "react-icons/fi";

import MLink from "../components/atoms/Link";
import colors from "styles/customTheme/colors";

import { reactStringReplace } from "./replace-string-w-component";

export function replaceStringWithLink(
  rawInput: string,
  fontStyle = "text-lg",
  color?: string,
  fontWeight = "700",
  marginLeft = "4px",
  width = "0.8rem",
  forcedExternal?: boolean,
  hideIcon?: boolean
): string {
  let output = "";

  const input = rawInput?.replace(/(?:\r\n|\r|\n)/g, "");
  if (input) {
    const elements = input.match(/\[.*?\)/g);
    if (elements != null && elements.length > 0) {
      for (const el of elements) {
        if (el !== null) {
          const txtMatch = el.match(/\[(.*?)\]/);
          const urlMatch = el.match(/\((.*?)\)/);

          if (txtMatch !== null && urlMatch !== null) {
            const txt = txtMatch[1];
            const url = urlMatch[1];

            let isExternal = true;

            if (typeof window !== "undefined") {
              const { host } = window.location;
              isExternal = forcedExternal || !url.includes(host);
            }

            output = input.replace(
              el,
              `<a href="${url}" target=${
                isExternal ? "_blank" : "_self"
              }>${txt}</a>`
            );
            output = reactStringReplace(
              output,
              `<a href="${url}" target=${
                isExternal ? "_blank" : "_self"
              }>${txt}</a>`,
              (match: string, i: number) => (
                <MLink
                  isExternal={isExternal}
                  key={match + i}
                  font={fontStyle}
                  fontWeight={fontWeight}
                  color={color || colors.marinadeGreen}
                  href={url}
                  _hover={{ textDecoration: "underline" }}
                  display="inline-flex"
                  alignItems="center"
                >
                  {txt}
                  {!hideIcon && (
                    <Icon
                      as={isExternal ? FiExternalLink : FiArrowRight}
                      width={width}
                      marginLeft={marginLeft}
                      cursor="pointer"
                      viewBox="0 -2 20 24"
                    />
                  )}
                </MLink>
              )
            ) as unknown as string;
          }
        }
      }
    }
  }
  return output;
}
